import {h} from 'ui/Framework';

export default h('svg', {
  width: '32',
  height: '40',
  viewBox: '-1 -1 34 42',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, [
    h('g', {
      stroke: '#21304A',
      strokeWidth: '2',
      fill: '#D8D8D8',
      fillOpacity: '0'
    }, [
      h('g', [
        h('path', {
          d: 'M16 39c.882 0 15-14.68 15-22.977S24.284 1 16 1C7.716 1 1 7.726 1 16.023S15.118 39 16 39zm0-14.14c4.873 0 8.824-3.956 8.824-8.837 0-4.88-3.95-8.837-8.824-8.837-4.873 0-8.824 3.957-8.824 8.837S11.126 24.86 16 24.86z',
          fill: 'none'
        })
      ])
    ])
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/field-location.es6.js